import React, { Component, Fragment } from "react";
import Grid from "react-bootstrap/lib/Grid";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";
import I18n from "pages/_components/I18n";
import Container from "pages/_components/Container";
import MainContainer from "pages/_components/MainContainer";
import Head from "pages/_components/Head";
import * as configUtils from "util/config";
import * as i18n from "util/i18n";
import ViewTitle from "./header/components/ViewTitle";

class LegalAdvice extends Component {
    backButtonAction = () => {
        const { history } = this.props;
        history.goBack();
    };

    render() {
        const subtitle = i18n.get("global.legalAdvice.subtitle", "Promoción Administración de Cartera");

        return (
            <Fragment>
                <MainContainer>
                    <Container>
                        <Col xs={12}>
                            <Head title="global.termAndConditions" onClose={this.backButtonAction} />
                            <ViewTitle id="global.legalAdvice.title" />
                        </Col>
                    </Container>
                    <Grid className="form-content">
                        <Row className="justify-content-center" style={{ textAlign: "justify" }}>
                            <Col className="col-12 scrollable-content">
                                <I18n id="global.legalAdvice.body" />
                            </Col>
                        </Row>
                    </Grid>

                    <h2 className="mt-10">{subtitle}</h2>

                    <Grid className="form-content">
                        <Row className="justify-content-center" style={{ textAlign: "justify" }}>
                            <Col className="col-12 scrollable-content mb-10">
                                <I18n id="global.legalAdvice.secondBody" />
                            </Col>
                        </Row>
                    </Grid>
                </MainContainer>
            </Fragment>
        );
    }
}

export default LegalAdvice;
